import React from 'react'
import LargeSwitch from '../../../largeSwitch/LargeSwitch'
import { FormFieldSwitchProps } from '../_props'

const FormFieldSwitch = <T extends object>({
    checked,
    onChange,
    name,
    switchLabel,
    status,
}: FormFieldSwitchProps<T>) => {
    const hasError = React.useMemo(() => {
        if (typeof status?.error === 'boolean' && status.error === true) return true

        if (status?.error !== undefined) return true

        return false
    }, [status?.error])

    return <LargeSwitch checked={checked} onChange={onChange} name={name} label={switchLabel} error={hasError} />
}

export default FormFieldSwitch
